<template>
  <cms-page :content="cmsPage"></cms-page>
</template>

<script>
import { defineComponent, useMeta } from '@nuxtjs/composition-api'
import CmsPage from '~/components/cms/CmsPage'
import { buildUrl, getSmallestMediaThumbnailUrl } from '~/helpers'

export default defineComponent({
  name: 'BlogView',
  components: { CmsPage },
  props: {
    cmsPage: {
      type: Object,
      default: () => ({}),
    },
    page: {
      type: Object,
      default: () => ({}),
    },
  },
  setup({ page }, { root }) {
    useMeta(() => ({
      title: page.blog.translated.metaTitle || page.blog.translated.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: page.blog.translated.metaDescription || '',
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: page.blog.translated.metaDescription || '',
        },
        {
          hid: 'og:title',
          name: 'og:title',
          content: page.blog.translated.metaTitle || page.blog.translated.title,
        },
        {
          hid: 'og:type',
          name: 'og:type',
          property: 'og:type',
          content: 'article',
        },
        page.blog.media
          ? {
              hid: 'og:image',
              name: 'og:image',
              property: 'og:image',
              content: getSmallestMediaThumbnailUrl(page.blog.media),
            }
          : {},
      ],
      link: [
        {
          rel: 'canonical',
          href: buildUrl(root.$config.appUrl, page.canonicalPathInfo || '/'),
        },
      ],
    }))
  },
  head: {},
})
</script>
